//add all cities data
import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import {
  Add_CancelReasons,
  Delete_CancelReasons,
  Get_All_CancelReasons,
  Get_Error,
  Get_One_CancelReasons,
  Update_One_CancelReasons,
} from '../Types';
import usegetdata from '../../Hooks/useGetData';
import usedeletedata from '../../Hooks/useDeleteData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';

export const Add_CancelReason_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/cancelreason`, body);

    dispatch({
      type: Add_CancelReasons,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all Cancelreasons data
export const GetAll_CancelReasons_Data = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/cancelreason?iscancelreasonactivate=true`);

    dispatch({
      type: Get_All_CancelReasons,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all Cancelreasons data
export const GetAll_CancelReasons_Data_Not_Activate = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/cancelreason?iscancelreasonactivate=false`);

    dispatch({
      type: Get_All_CancelReasons,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get one Area data
export const DeleteOne_CancelReasons_Data = (id) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/cancelreason/${id}`);

    dispatch({
      type: Delete_CancelReasons,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all Area data
export const GetOne_CancelReasons_Data = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/cancelreason/${id}`);

    dispatch({
      type: Get_One_CancelReasons,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//Update one Area data
export const UpdateOne_CancelReasons_Data = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/cancelreason/${id}`, body);

    dispatch({
      type: Update_One_CancelReasons,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
